import React from 'react';

import QuestionTrackerModal from './QuestionTrackerModal/QuestionTrackerModal';
import UpgradeCallToActionModal from './UpgradeCallToActionModal/UpgradeCallToActionModal';

interface Props {
  pathname: string;
}

export default function ModalCollection({pathname}: Props) {
  return (
    <>
      <UpgradeCallToActionModal pathname={pathname} />
      <QuestionTrackerModal />
    </>
  );
}
